import { ajax } from '../ajax'


//、 授课-课中画像 教学轨迹
export const reqSKteachingTrack = (paramets) => ajax(`/homepage/teachingHomepage/getTeachingTrack`, paramets)

//、 授课-课中画像 到课率
export const reqSKcourseRatio = (paramets) => ajax(`/homepage/teachingHomepage/getAttendanceRate`, paramets)

//、 授课-课中画像 作业率
export const reqSKhomeworkRatio = (paramets) => ajax(`/homepage/teachingHomepage/getHomeworkCompletionRate`, paramets)

//、 授课-课中画像 任务率
export const reqSKtaskRatio = (paramets) => ajax(`/homepage/teachingHomepage/getTaskCompletionRate`, paramets)

//、 授课-课中画像 测试率
export const reqSKtestRatio = (paramets) => ajax(`/homepage/teachingHomepage/getTestAccuracy`, paramets)

//、 授课-课中画像 小组排名
export const reqSKgroupList = (paramets) => ajax(`/homepage/teachingHomepage/getGroupList`, paramets)

//、 授课-课中画像 学生进步排名
export const reqSKstuImproveList = (paramets) => ajax(`/homepage/teachingHomepage/progressRankList`, paramets)

//、 授课-课中画像 学生活跃排名
export const reqSKstuLivelyList = (paramets) => ajax(`/homepage/teachingHomepage/activeRankList`, paramets)

//、 授课-课中画像 学生素质排名
export const reqSKstuQualityList = (paramets) => ajax(`/homepage/teachingHomepage/moralismRankList`, paramets)

//、 授课-课中画像 学生综合活跃排名
export const reqSKstuAchievementList = (paramets) => ajax(`/homepage/teachingHomepage/synthesizeRankList`, paramets)

//、 授课-课中画像 活动参与率
export const reqSKactiveRatio = (paramets) => ajax(`/homepage/teachingHomepage/participationRankList`, paramets)



// WEBPACK FOOTER //
// ./src/api/give-course/portrayal.js